import { render, staticRenderFns } from "./transfer_count.vue?vue&type=template&id=308bd433&scoped=true&"
import script from "./transfer_count.vue?vue&type=script&lang=js&"
export * from "./transfer_count.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308bd433",
  null
  
)

export default component.exports